// Wraps react-router-dom (aliased in craco.config.js) so links to public pages keep the page's language prefix.
import { forwardRef, useCallback } from "react";
import { Link as RLink, NavLink as RNavLink, Navigate as RNavigate, useNavigate as rUseNavigate } from "react-router-dom-original";
import { useI18n } from "../i18n/I18nContext";
import { withLang } from "./langPath";

export * from "react-router-dom-original";

function useLocalize() {
  const { lang } = useI18n();
  return useCallback((to) => {
    if (typeof to !== "string" || !to.startsWith("/") || to.startsWith("/api")) return to;
    const [path, rest] = to.split(/(?=[?#])/);
    // Discussions exist only in their own language; their links are built explicitly (QuestionCard) or fixed on the page.
    if (/^\/(hi\/|hinglish\/)?community\/question\//.test(path)) return path.replace(/^\/(hi|hinglish)(?=\/)/, "") + (rest || "");
    return withLang(path, lang) + (rest || "");
  }, [lang]);
}

export const Link = forwardRef(function Link({ to, ...props }, ref) {
  return <RLink ref={ref} to={useLocalize()(to)} {...props} />;
});

export const NavLink = forwardRef(function NavLink({ to, ...props }, ref) {
  return <RNavLink ref={ref} to={useLocalize()(to)} {...props} />;
});

export function Navigate({ to, ...props }) {
  return <RNavigate to={useLocalize()(to)} {...props} />;
}

export function useNavigate() {
  const nav = rUseNavigate();
  const loc = useLocalize();
  return useCallback((to, opts) => nav(loc(to), opts), [nav, loc]);
}
